// Primary 3 English Learning Data
// Combined from p3Data-part1.js and p3Data-part2.js
// Based on Primary English Learning P3 Topics.txt

import { p3DataPart1 } from './p3Data-part1';
import { p3DataPart2 } from './p3Data-part2';

export const p3Data = {
  gradeId: p3DataPart1.gradeId,
  gradeName: p3DataPart1.gradeName,
  objectives: p3DataPart1.objectives,
  keySkills: p3DataPart1.keySkills,
  topics: [
    ...p3DataPart1.topics,
    ...p3DataPart2.topics
  ]
}; 